/** @format */

export const api = process.env.VUE_APP_URL;
export const api_absolute = process.env.VUE_APP_URL_ABSOLUTE;
export const google_auth_url = process.env.VUE_APP_GOOGLE_AUTH_URL;
export const service = process.env.VUE_APP_SERVICE;
export const origin = process.env.VUE_APP_ORIGIN;
export const reference = process.env.VUE_APP_REFERENCE;
export const landing = process.env.VUE_APP_LANDING;
// FRONTEND_URL (sin prefijo VUE_APP_) no lo inyecta vue-cli: quedaba undefined
export const frontend_url =
	process.env.VUE_APP_FRONTEND_URL ||
	(typeof window !== 'undefined' ? window.location.origin : '');
export const notification_url = process.env.VUE_APP_NOTIFICATION_URL;
export const NODE_ENV = process.env.NODE_ENV;
